import * as React from 'react';
import { useSelector } from 'react-redux';
import { useCreditApp } from '../hooks/useCreditApp';
import { useCreditAppMessages } from '../hooks/useCreditAppMessages';
import { CreditAppIframe } from './CreditAppIframe';
import { creditAppSelectors } from '../store/config';
import CreditAppSummary from './CreditAppSummary';

/**
 * Credit App Root - Uses STANDALONE mode
 * Standalone mode provides independent credit application without deal integration
 *
 * Conditionally renders:
 * - CreditAppSummary: When credit app is completed (shows summary instead of iframe)
 * - CreditAppIframe: When credit app is not completed (shows iframe)
 */
const CreditAppRoot: React.FC = () => {
    const { creditAppUrl } = useCreditApp();
    useCreditAppMessages();

    // Check if credit app is completed - if so, show summary instead of iframe
    const isCompleted = useSelector(creditAppSelectors.isCreditAppCompleted);

    if (isCompleted) {
        return <CreditAppSummary />;
    }

    return (
        <div className="creditapp-activity-wrapper" data-testid="standalone-creditapp">
            <CreditAppIframe src={creditAppUrl} />
        </div>
    );
};

export default CreditAppRoot;
